export default __webpack_public_path__ + "static/media/twitter.73140617.svg";